import { EventType, STATUS_ICONS } from "../utils"

export const createEventTextTemplate = () => {
  return function eventTextTemplate(start: Date, end: Date, event: EventType) {
    if (event.type === "todo") {
      return `
          <div class="dhx_todo_event">
            <span class="dhx_calendar_title">${event.text}</span>
            <span class="todo-checkbox-root" data-id="${event.id}"></span>
          </div>
        `
    }

    if (event.type === "task" && event.status) {
      const icon = STATUS_ICONS[event.status]
      return `
          <div class="dhx_task_event">
            <span class="dhx_calendar_task_title">${event.text}</span>
            <span class="dhx_calendar_task_status">${icon}</span>
          </div>
        `
    }
    return `<span class="dhx_calendar_title">${event.text}</span>`
  }
}

export const createEventBarTemplate = () => {
  return function eventBarTemplate(start: Date, end: Date, event: EventType) {
    if (event.type === "task" && event.status) {
      const icon = STATUS_ICONS[event.status]
      return `
          <div class="dhx_task_bar_event">
            <span class="dhx_calendar_task_title">${event.text}</span>
            <span class="dhx_calendar_task_icon">${icon}</span>
          </div>
        `
    }

    return `<span>${event.text}</span>`
  }
}
